import { useEffect } from 'react'

import { clsx } from 'clsx'
import { Link, useLocation, useOutletContext } from 'react-router'

import { useScrollIntoView } from '~/hooks/useScrollIntoView'
import { GraphQlComponentItem } from '~/types/content'
import { RootOutletContext } from '~/types/portal'

export const GraphQlSubNavItem = ({
  parentPath,
  graphQlComponentItem,
  active = false,
  isSelected,
  setSelectedGraphQlComponentItem,
  onClick,
  expandable = true,
}: {
  parentPath: string,
  graphQlComponentItem: GraphQlComponentItem,
  active?: boolean,
  isSelected: boolean,
  setSelectedGraphQlComponentItem: (selectedGraphQlComponentItem: string | null) => void,
  onClick?: (e) => void,
  expandable?: boolean,
}) => {
  const { hash: locationHash } = useLocation()

  const isCurrentHash = `#${graphQlComponentItem.id}` === locationHash

  useEffect(() => {
    if (active && isCurrentHash) {
      setSelectedGraphQlComponentItem(graphQlComponentItem.id)
    } else if (!active) {
      setSelectedGraphQlComponentItem(null)
    }
  }, [active, locationHash, setSelectedGraphQlComponentItem, graphQlComponentItem.id])

  const navActiveItemRef = useScrollIntoView<HTMLAnchorElement>()

  const { closeSideNavWithoutTransition } = useOutletContext<RootOutletContext>()

  const onNavigate = (e) => {
    onClick?.(e)
    closeSideNavWithoutTransition?.()
  }

  return (
    <Link to={`${parentPath}#${graphQlComponentItem.id}`}
      onClick={onNavigate}
      className={clsx(
        'ml-1 flex pr-8 rounded max-w-full overflow-hidden z-40',
        active && 'hover:bg-neutral-20 dark:hover:bg-neutral-90',
        isSelected ? 'bg-neutral-20 dark:bg-neutral-90 text-consumer-blue dark:text-dark-consumer-blue font-semibold' : '',
        expandable ? 'py-1.5 pl-2' : 'pl-6 py-0.5 font-semibold'
      )}
      ref={(active && isCurrentHash) ? navActiveItemRef : null}
    >
      <div className="overflow-hidden break-words">
        {graphQlComponentItem.title}
      </div>
    </Link>
  )
}